import FavoriteControl from "./FavoriteControl";

export default FavoriteControl;
